module.exports = __webpack_public_path__ + "img/defeat-mask.463ffa22.png";